import styled from 'styled-components';

import { 
  PADDING_CONTENT_PAGE, BACKGROUND_TABLE_TIMES, BACKGROUND_TABLE_TIMES_HOVER, BORDER_COLOR_TABLE_TIMES,
  FONT_SIZE_TABLE_TIMES_ROW, FONT_SIZE_TABLE_TIMES_HEADER, COLOR_TABLE_TIMES_FULL, COLOR_TABLE_TIMES_HOVER,
} from '../../../globals';


export const StyledIntervals = styled.li`
  margin: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  padding-bottom: 6px;

  button {
    border: none;
    background-color: ${BACKGROUND_TABLE_TIMES};
    width: 100%;
    font-size: 1.1em;
  }

  .free-interval {

  }

  .free-interval:hover {
    background-color: ${BACKGROUND_TABLE_TIMES_HOVER};
    color: ${COLOR_TABLE_TIMES_HOVER};
  }

  .full-interval {
    color: ${COLOR_TABLE_TIMES_FULL};
    cursor: not-allowed;
  }

  .time {
    float: left;
    padding: 6px 15px 6px 5px;
  }

  .capacity {
    float: left;
    padding: 6px 5px 6px 30px;
  }

  .icon {
    float: right;
    vertical-align: middle;
    font-size: 15px;
    padding: 6px 15px 6px 15px;
  }
`;